// extracted by mini-css-extract-plugin
module.exports = {"wrap":"legend_wrap_TLtzb","fanhui":"legend_fanhui_4SyV-","fullScreen":"legend_fullScreen_1vezz"};